"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosPurchaseOrderReceiveInputSchema = exports.APosPurchaseOrderCreateInputSchema = exports.APosPurchaseOrderSchema = exports.APosPurchaseOrderItemSchema = exports.APosPurchaseOrderStatusSchema = void 0;
const zod_1 = require("zod");
const timestamps_schema_1 = require("../../common/timestamps.schema");
const id_schema_1 = require("../../common/id.schema");
exports.APosPurchaseOrderStatusSchema = zod_1.z.enum([
    'draft', 'approved', 'sent', 'partially_received', 'received', 'cancelled',
]);
exports.APosPurchaseOrderItemSchema = zod_1.z.object({
    lineId: id_schema_1.EntityIdSchema,
    variantId: id_schema_1.EntityIdSchema,
    productId: id_schema_1.EntityIdSchema,
    displayName: zod_1.z.string().min(1),
    sku: zod_1.z.string().optional(),
    orderedQuantity: zod_1.z.number().int().positive(),
    receivedQuantity: zod_1.z.number().int().nonnegative().default(0),
    damagedQuantity: zod_1.z.number().int().nonnegative().default(0),
    unitCost: zod_1.z.number().nonnegative(),
    lineTotal: zod_1.z.number().nonnegative(),
    taxRate: zod_1.z.number().min(0).max(1).default(0),
    taxAmount: zod_1.z.number().nonnegative().default(0),
    batchNumber: zod_1.z.string().optional(),
    expiryDate: zod_1.z.number().optional(),
    notes: zod_1.z.string().max(500).optional(),
});
exports.APosPurchaseOrderSchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    purchaseOrderId: id_schema_1.EntityIdSchema,
    poNumber: zod_1.z.string().min(1),
    locationId: id_schema_1.EntityIdSchema,
    supplierId: id_schema_1.EntityIdSchema,
    supplierName: zod_1.z.string().min(1),
    items: zod_1.z.array(exports.APosPurchaseOrderItemSchema).min(1),
    subtotal: zod_1.z.number().nonnegative(),
    taxTotal: zod_1.z.number().nonnegative().default(0),
    shippingCost: zod_1.z.number().nonnegative().default(0),
    grandTotal: zod_1.z.number().nonnegative(),
    status: exports.APosPurchaseOrderStatusSchema.default('draft'),
    expectedDeliveryDate: zod_1.z.number().optional(),
    approvedBy: id_schema_1.EntityIdSchema.optional(),
    approvedAt: zod_1.z.number().optional(),
    sentAt: zod_1.z.number().optional(),
    sentMethod: zod_1.z.enum(['email', 'manual', 'edi']).optional(),
    receivedAt: zod_1.z.number().optional(),
    receivedBy: id_schema_1.EntityIdSchema.optional(),
    cancelledAt: zod_1.z.number().optional(),
    cancelledBy: id_schema_1.EntityIdSchema.optional(),
    cancelReason: zod_1.z.string().max(500).optional(),
    paymentTerms: zod_1.z.enum([
        'net_7', 'net_15', 'net_30', 'net_45', 'net_60',
        'cod', 'prepaid', 'on_account',
    ]).optional(),
    notes: zod_1.z.string().max(2000).optional(),
    internalNotes: zod_1.z.string().max(2000).optional(),
    createdBy: id_schema_1.EntityIdSchema,
}).merge(timestamps_schema_1.TimestampsSchema);
exports.APosPurchaseOrderCreateInputSchema = zod_1.z.object({
    locationId: id_schema_1.EntityIdSchema,
    supplierId: id_schema_1.EntityIdSchema,
    items: zod_1.z.array(zod_1.z.object({
        variantId: id_schema_1.EntityIdSchema,
        productId: id_schema_1.EntityIdSchema,
        displayName: zod_1.z.string().min(1),
        sku: zod_1.z.string().optional(),
        orderedQuantity: zod_1.z.number().int().positive(),
        unitCost: zod_1.z.number().nonnegative(),
        taxRate: zod_1.z.number().min(0).max(1).optional(),
        notes: zod_1.z.string().max(500).optional(),
    })).min(1),
    expectedDeliveryDate: zod_1.z.number().optional(),
    paymentTerms: exports.APosPurchaseOrderSchema.shape.paymentTerms,
    shippingCost: zod_1.z.number().nonnegative().optional(),
    notes: zod_1.z.string().max(2000).optional(),
});
exports.APosPurchaseOrderReceiveInputSchema = zod_1.z.object({
    items: zod_1.z.array(zod_1.z.object({
        lineId: id_schema_1.EntityIdSchema,
        receivedQuantity: zod_1.z.number().int().nonnegative(),
        damagedQuantity: zod_1.z.number().int().nonnegative().optional(),
        batchNumber: zod_1.z.string().optional(),
        expiryDate: zod_1.z.number().optional(),
        notes: zod_1.z.string().max(500).optional(),
    })).min(1),
    receiveNotes: zod_1.z.string().max(2000).optional(),
});
//# sourceMappingURL=purchase-order.schema.js.map